export default "__VITE_ASSET__88d06e45__"